import { promoBasketPopupReducer } from '../../promo-basket-popup/reducers/PromoBasketPopupReducer';
const loadPromoBasketPopupModule = () => ({
    id: 'PromoBasketPopup',
    reducerMap: {
        promoBasketPopup: promoBasketPopupReducer,
    },
    sagas: [],
});
export default loadPromoBasketPopupModule;
